<template>
  <div
    style="
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      height: 100%;
      padding-top: 10px;
      padding-bottom: 10px;
    "
  >
    <div style="display: flex; justify-content: space-between; width: 100%">
      <v-tooltip bottom v-if="isOverflowing($refs.name)">
        <template v-slot:activator="{ on, attrs }">
          <div
            ref="name"
            style="color: black; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; max-width: 50%"
            v-bind="attrs"
            v-on="on"
          >
            {{ item.name }}
          </div>
        </template>
        <span>{{ item.name }}</span>
      </v-tooltip>
      <div
        v-else
        ref="name"
        style="color: black; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; max-width: 50%"
      >
        {{ item.name || '-' }}
      </div>
      <div style="color: #797979">
        {{ formattedDob || '-' }}
      </div>
    </div>
    <div style="display: flex; justify-content: space-between; width: 100%">
      <div style="color: #797979; white-space: nowrap">{{ item.code_short || '-' }}</div>
      <div style="color: #797979; white-space: nowrap">
        {{ item.gender && item.gender !== '-' ? studentGender : '-' }}
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'

export default {
  props: {
    item: {
      type: Object,
      default: () => ({ name: '-', code_short: '-', dob: '-', gender: '-' })
    }
  },
  computed: {
    studentGender() {
      if (this.item && this.item.gender) {
        switch (this.item.gender) {
          case 'male':
            return 'Nam'
          case 'female':
            return 'Nữ'
          case 'other':
            return 'Khác'
          default:
            return '-'
        }
      } else {
        return '-'
      }
    },
    formattedDob() {
      return this.item.dob ? moment(this.item.dob, 'YYYY-MM-DD').format('DD/MM/YYYY') : '-'
    }
  },
  methods: {
    isOverflowing(ref) {
      if (ref && ref.offsetWidth < ref.scrollWidth) {
        return true
      }
      return false
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.$forceUpdate()
    })
  }
}
</script>
